import React, { Component, ErrorInfo, ReactNode } from 'react'

type ComponentDidCatchProps = {
  fallback: (_: { error: [Error, ErrorInfo] }) => ReactNode
  children: ReactNode
}
type ComponentDidCatchState = {
  error?: [Error, ErrorInfo]
}
export class ComponentDidCatch extends Component<ComponentDidCatchProps, ComponentDidCatchState> {
  constructor(props: ComponentDidCatchProps) {
    super(props)
    this.state = {}
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error: [error, errorInfo] })
  }

  render() {
    return this.state.error === undefined ? (
      this.props.children
    ) : (
      <this.props.fallback error={this.state.error}></this.props.fallback>
    )
  }
}
